// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__YiXtH","unreadBadge":"styles_unreadBadge__AcciT","modalContent":"styles_modalContent__1MGNg","modal":"styles_modal__3sH3Z"};